import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature, hasFeatureValue} from '../../../util/values';
import {
	selectHasBuriedBase,
	selectHeightDecided,
	selectIsOnesided,
	selectMeasures,
	selectModulePosPx,
	selectTotalHeightPx,
	selectIsBollard,
	selectSpcConfiguration
} from '../../../selectors';

@customElement('svg-productimage')
export class SvgProductimage extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			justify-content: center;
			height: 95%;
			width: 100%;
			margin-top: 5%;
		}

		svg {
			height: 100%;
			width: 100%;
		}

    `;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.status = state.status;
	}

	render() {
		const s = this.state;
		const modulePosPx = selectModulePosPx(s);
		const measures = selectMeasures(s);
		const height = selectTotalHeightPx(s);
		let poleHeight = getValueOfFeature('root::Poles::Pole::Basic::HS_Height', this.spcConfiguration);
		//console.log('poleHeight', poleHeight);
		poleHeight = poleHeight.length === 4 ? poleHeight.substring(0, 2) : '0' + poleHeight.substring(0, 1);

		const svgPath = this.status.host + this.status.baseUrl + (selectIsBollard(s) ? '/visuals/line-productimage-bollard.svg' : '/visuals/line-productimage-column.svg');
		const imgHeight = selectIsBollard(s) ? 141 : 792;
		return svg`<svg class="productimage-export" id="productimage-svg" height="${imgHeight+'px'}" viewBox="0 0 100 ${imgHeight}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<g id="LineSVG" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0, ${imgHeight-height})">
						<use href="${svgPath}#${getValueOfFeature('shared::ProductType::HS_HousingType', this.spcConfiguration)}_${poleHeight}"></use>

					${when(selectHeightDecided(s), () => svg`
						<use href="${svgPath}#${getValueOfFeature('root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour', this.spcConfiguration)}_${getValueOfFeature('root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize', this.spcConfiguration)}_1" y="${modulePosPx.m1top}"></use>
						${when(!selectIsOnesided(s), () => svg`
							<use href="${svgPath}#${getValueOfFeature('root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ReflectorColour', this.spcConfiguration)}_${getValueOfFeature('root::Heads::Head_2:Type::Luminaire::LightEngine::LE_LightEngineModuleSize', this.spcConfiguration)}_2" y="${(modulePosPx.m1top + modulePosPx.between)}"></use>
						`)}
					`)}
					${when(selectHasBuriedBase(s), () => svg`
						<use href="${svgPath}#${getValueOfFeature('root::Poles::Pole::Basic::HS_Base', this.spcConfiguration)}</use>
					`)}
					</g>
				</svg>`;
	}
}
